import { ILanguage, IProjectLanguageData } from "../../../model/model";
import { collectNodeIssues, NodeIssue } from "./graphValidator";
import { collectNodeLanguageIssues } from "./languageValidator";
import { Node } from "./nodeTypes";

export type GraphIssueWithNode = { node: Node; issue: NodeIssue };

export const groupPldsByContentId = (
  plds: IProjectLanguageData[],
): Map<number, IProjectLanguageData[]> => {
  const map = new Map<number, IProjectLanguageData[]>();
  for (const pld of plds) {
    const list = map.get(Number(pld.content)) ?? [];
    list.push(pld);
    map.set(Number(pld.content), list);
  }
  return map;
};

// Single source of truth for "every problem in this graph" — shared by the
// graph page's issues panel and the publication module cards, so both always
// give the same diagnosis. Render-only clones of shared assets are skipped so
// an issue is listed once per real content.
export const collectGraphIssues = (
  nodes: Node[],
  pldsByContentId: Map<number, IProjectLanguageData[]>,
  enabledLanguages: ILanguage[],
): GraphIssueWithNode[] => {
  const result: GraphIssueWithNode[] = [];
  for (const node of nodes) {
    if (node.type === "asset" && node.duplicatedForSceneId) continue;
    const nodeIssues = [
      ...collectNodeIssues(node),
      ...collectNodeLanguageIssues(
        node,
        pldsByContentId.get(Number(node.contentId)) ?? [],
        enabledLanguages,
      ),
    ];
    for (const issue of nodeIssues) result.push({ node, issue });
  }
  return result;
};
